import React from 'react';
import { FormattedText } from 'core/i18n';
import CustomScrollBar from 'components/customScrollBar/customScrollBar';
import ModalBox from 'components/modalBox/modalBox';
import { ProductsInformation } from '../../../../ProductsInformation/ProductsInformation';
import { LegalInfoByCountry } from '../../../../LegalInfoByCountry/LegalInfoByCountry';
import { LEGAL_MODAL_LEGAL_INFO_BY_COUNTRY } from './constants';

const { LEGAL_INFO, LEGAL_INFO_BY_COUNTRY } = LEGAL_MODAL_LEGAL_INFO_BY_COUNTRY;

export const LegalModal = ({ anchor, productsInfo }) => {
    return (
        <ModalBox
            bsSize="large"
            className="icons icons--icon-ancla"
            textButton=""
            width={800}
            textButtonClose={<FormattedText value="button-exitModal" />}
            modalLogo={<i className="icons icons--icon-openbank-logo" />}
            openButton={true}
            anchorNro={anchor}
        >
            <div className="legal-info__doc-block-modal">
                <CustomScrollBar width="100%" autoHeightMin={495}>
                    <div>
                        <FormattedText value="documentation-gdprLegalInfo" injectedStrings={['', '']} />
                        <FormattedText value="documentation-precontractualInformation" injectedStrings={['']} />
                        <ProductsInformation productsInfo={productsInfo} />
                        <LegalInfoByCountry legalInfo={LEGAL_INFO} legalInfoByCountry={LEGAL_INFO_BY_COUNTRY} />
                    </div>
                </CustomScrollBar>
            </div>
        </ModalBox>
    );
};
